import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import Turnstile from "react-cloudflare-turnstile";
import { useForm } from "react-hook-form";
import logo from "../../assets/images/logo.png";
import axiosPost from "../../helpers/axiosPost";
import "../../custom.css";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getPlaceholderByType } from "../../helpers/getPlaceHolderByType";

export default function HomePage() {
  useEffect(() => {
    sessionStorage.clear();
  }, []);
  
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);

  const { type } = useParams();
  const [searchParams] = useSearchParams();
  const uniqId = searchParams.get("id");

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const handleSubmitForm = (data) => {
    setLoading(true);

    if (!captchaValue) {
      setError({
        message: "Please complete the captcha!",
        statusCode: 401,
      });
      setShow(true);
      setLoading(false);
      return;
    }

    const body = {
      uniqId: uniqId,
      key: data.key,
      token: captchaValue,
    };

    axiosPost({
      url: `/v2/qr-service/validation`,
      data: body,
      callback: (res) => {
        sessionStorage.setItem("fileUrl", res.data.url);
        sessionStorage.setItem("uniqId", uniqId);
        sessionStorage.setItem("key", data.key);
        navigate(`/${type}/preview`);
      },
      errorCallback: (err) => {
        setLoading(false);
        setShow(true);
        setError(err);
      },
    });
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const placeholder = getPlaceholderByType(type);

  return (
    <>
      <div className="position-relative">
        <ToastContainer position="top-end">
          <Toast
            className="m-5"
            style={{
              border: "none",
              boxShadow: "0px 0px 16px 20px rgba(100, 100, 100, 0.03)",
              background: "#ffe5e5",
            }}
            onClose={() => setShow(false)}
            show={show}
            delay={5000}
            autohide
          >
            <Toast.Header>
              <strong className="me-auto" style={{ color: "#e96b6b" }}>
                Error!
              </strong>
            </Toast.Header>
            <Toast.Body style={{ color: "#e96b6b" }}>
              {error?.message}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
      <Container className="py-5">
        <div id="home-page">
          <div className="bg-gradient"></div>
          <div className="home-wrapper">
            <div className="section-form">
              <div className="title-section-home">
                <div className="title mb-4">
                  <img src={logo} className="background" alt="background" />
                </div>
                {/* <div className="subtitle">Generate Document</div> */}
              </div>
              <div style={{ position: "relative", width: "100%" }}>
                <Form onSubmit={handleSubmit(handleSubmitForm)}>
                  <Form.Group>
                    <Form.Label className="form-label">
                      {placeholder} <span>*</span>
                    </Form.Label>
                    <Form.Control
                      className="form-input"
                      type="text"
                      name="key"
                      placeholder={`Insert ${placeholder}`}
                      {...register("key", {
                        required: "Key Harus Diisi!",
                      })}
                    />
                    <p
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginTop: "5px",
                      }}
                    >
                      {errors.username?.message}
                    </p>
                  </Form.Group>
                  <div className="flex justify-center mb-0">
                    <Turnstile
                      turnstileSiteKey={siteKey}
                      callback={handleCaptchaChange}
                    />
                  </div>
                  <div className="footer-home">
                    <Row>
                      <Col>
                        <div className="btn-wrapper">
                          <Button
                            type="submit"
                            className="btn btn-submit btn-submit"
                            disabled={loading}
                          >
                            Submit
                            {loading && (
                              <Spinner
                                style={{ marginLeft: "8px" }}
                                animation="border"
                                variant="light"
                                size="sm"
                              />
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
